import React from 'react';
import PropTypes from 'prop-types';
import "./Button.scss";

const Button = ({text, onClick, className, link}) => {

  if (link) {
    return <a href={link} target={"_blank"} rel={"noreferrer noopener"} className={`btn ${className}`} onClick={onClick}>{text}</a>
  } else {
    return (
        <button className={`btn ${className}`} onClick={onClick}>{text}</button>
    );
  }

};

Button.defaultProps = {
  className: "",
  onClick: () => {},
  text: ""
};

Button.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
};

export default Button;
